import {getFunctions,httpsCallable} from 'firebase/functions';
export const gestionarConsumo=async data=>(await httpsCallable(getFunctions(),'gestionarConsumo')(data)).data;
